import React from 'react';
import ImageZoom from 'react-medium-image-zoom';

import ProjectHeader from './ProjectHeader';

import coverImg from '../../imgs/Hashing/coverImg-Taichi-case.png';
import WhatIlearned from '../../imgs/Hashing/design-highlights.png';
import projectsetup from '../../imgs/Hashing/portal.png';
import api from '../../imgs/Hashing/api.png';
import portal from '../../imgs/Hashing/Taichi-Enode-Integration.gif';

import preintegration from '../../imgs/Hashing/Taichi-Flow.gif';
// import preintegration from '../../imgs/Hashing/Taichi-Overview.png';
import overviewDetails from '../../imgs/Hashing/Pre-integration.png';
import postintegration from '../../imgs/Hashing/Customer-Data.png';
import customerDetails from '../../imgs/Hashing/Post-integration.png';

// const ListInSection = ({ data }) => {
//   return (
//     <ul className="list-in-section">
//       {data.map((item, index) => {
//         return (
//           <li key={index}>
//             <h4>{index + 1}.</h4>
//             <p>
//               <strong>{item.header}</strong>
//             </p>
//             <p>{item.content}</p>
//           </li>
//         );
//       })}
//     </ul>
//   );
// };

const Hashing = () => (
  <div className="caseBody">
    <section className="head">
      <h2>Crypto Dashboard Development</h2>
      <p className="caseIntro">Hashing Group</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Overview</h3>
      </div>
      <div className="right">
        <p className="content-p">
          Taichi is a high-speed block and transaction delivery network designed
          to enhance the connectivity of Ethereum node runners. It leverages the
          resilience and scalability of peer-to-peer networks while accelerating
          information flow for the blockchain.
        </p>
        <h4>Taichi Network 🕸️</h4>
        <p className="content-p">
          <i>// Some behind-the-scene if you feel technical... </i>
        </p>

        <p className="content-p">
          <strong>High-Efficiency Nodes </strong>
          <p>
            Taichi nodes handle thousands of peers and are deployed globally to
            maximize peer connectivity.
          </p>
        </p>

        <p className="content-p">
          <strong>Dedicated Backbone Network </strong>
          <p>
            Direct connections between Taichi nodes ensure efficient
            communication.
          </p>
        </p>

        <p className="content-p">
          <strong>Optimized Broadcasting </strong>
          <p>
            Transactions are guaranteed to reach any connected node within 3
            hops, significantly reducing latency.{' '}
          </p>
        </p>

        <h4>Design Highlights</h4>
        <p />
        <img
          className="img-responsive img-centered"
          src={WhatIlearned}
          alt=""
        />
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Key Features</h3>
      </div>
      <div className="right">
        <p className="content-p">
          Taichi is a high-speed block and transaction delivery network designed
          to enhance the connectivity of Ethereum node runners. It leverages the
          resilience and scalability of peer-to-peer networks while accelerating
          information flow for the blockchain.
        </p>
        <h4> Onboarding: Choose the Integration Type</h4>
        <p className="content-p">
          Customer research indicates that users frequently integrate with API
          or Enode. Therefore, the Taichi Platform offers two integration
          methods, each with step-by-step guidance.
        </p>
        <p />
        <img
          className="img-responsive img-centered"
          src={projectsetup}
          alt=""
        />
        <p className="content-p">
          <strong>Integrate with Enodes: </strong>
        </p>
        <img className="img-responsive img-centered" src={portal} alt="" />
        <p className="content-p">
          <strong>Integrate with API: </strong>
        </p>
        <img className="img-responsive img-centered" src={api} alt="" />

        <h4> Pre-Integration Overview</h4>
        <p className="content-p">
          The overview is publicly accessible, showcasing Taichi's performance
          and promoting our service to new visitors. It offers data-driven
          insights and displays data even for users who have not yet integrated
          with us.
        </p>
        <img
          className="img-responsive img-centered"
          src={preintegration}
          alt=""
        />

        <img
          className="img-responsive img-centered"
          src={overviewDetails}
          alt=""
        />
        <h4> Post-integration Customer Data Display</h4>
        <p className="content-p">
          Upon completing the integration, Taichi begins receiving data from
          customers. This allows us to provide a detailed view for each
          customer, assisting users in making informed, data-driven decisions.
        </p>
        <img
          className="img-responsive img-centered"
          src={postintegration}
          alt="image shows the customer data view"
        />

        <img
          className="img-responsive img-centered"
          src={customerDetails}
          alt="image shows the customer data view in details"
        />
      </div>
    </section>
  </div>
);

export default Hashing;



// WEBPACK FOOTER //
// ./src/Modules/Case/Hashing.js